import { translationKeys } from "../util/translationKeys"

export const errorCodes = {
  PRODUCT_NOT_AVAILABLE: "product_not_available",
  COULD_NOT_ADD_VOUCHER_TO_ORDER: "could_not_add_voucher_on_order",
  NO_TIMESLOTS_AVAILABLE: "no_timeslots_available",
  TIMESLOT_MAX_CAPACITY_REACHED: "timeslot_max_capacity_reached",
  TIMESLOT_CAPACITY_REACHED: "timeslot_capacity_reached",
  TIMESLOT_NOT_AVAILABLE: "timeslot_not_available",
  MINIMUM_PRICE_NOT_MET: "minimum_price_not_met",
  VENUE_CLOSED_FOR_ORDERS: "venue_closed_for_orders",
  OUTSIDE_OPENING_HOURS: "outside_opening_hours",
  VALIDATION_ERROR: "validation_error",
  INVALID_REQUEST: "invalid_request",
  IS_BLANK_ERROR: "is_blank_error",
  TRY_AGAIN_LATER: "try_again_later",
  TERMS_NOT_ACCEPTED: "terms_not_accepted",
  USER_EXISTS: "user_exists",
  MISSING_EMAIL_VERIFICATION_CODE: "missing_email_verification_code",
  UNKNOWN_OR_EXPIRED_EMAIL_VERIFICATION_CODE:
    "unknown_or_expired_email_verification_code",
  NOT_FOUND: "not_found",
  UNKNOWN_USERNAME_OR_PASSWORD: "unknown_username_or_password",
  UNKNOWN_USER_OR_WRONG_PASSWORD: "unknown_user_or_wrong_password",
  INVALID_OR_EXPIRED_EMPLOYEE_ID: "invalid_or_expired_employee_id",
  EMPLOYEE_ID_ALREADY_USED: "employee_id_already_used",
  ERROR_CARD_NUMBER_ALREADY_REGISTERED: "error_card_number_already_registered",
  ERROR_CARD_NOT_NUMBER_FOUND: "error_card_not_number_found",
  ERROR_UNKNOWN_CARD_TYPE: "error_unknown_card_type",
  ACTIVE_SUBSCRIPTION_CARD_CAN_NOT_BE_REMOVED:
    "active_subscription_card_can_not_be_removed",
  MISSING_ACTIVE_SUBSCRIPTION: "missing_active_subscription",
  MAX_ACCOUNT_BALANCE_REACHED: "max_account_balance_reached",
  ERROR_CHARGE: "error_charge",
  REQUIRES_ACTION: "requires_action",
  INVALID_PAYMENT_METHOD: "invalid_payment_method",
  MAX_DEPOSIT_AMOUNT_REACHED: "max_deposit_amount_reached",
  INVALID_CURRENCY: "invalid_currency",
  CODE_IS_NO_LONGER_VALID: "code_is_no_longer_valid",
  CODE_ALREADY_USED: "code_already_used",
  CUSTOMER_ALREADY_ADDED: "customer_already_added",
  NOT_TRIAL_ELIGIBLE: "not_trial_eligible",
  REFERRAL_NOT_ACTIVE: "referral_not_active",
  CODE_NOT_FOUND: "code_not_found",
  RESOURCE_NOT_FOUND: "resource_not_found",
  ITEM_NOT_FOUND: "item_not_found",
  TOO_MANY_REQUESTS: "too_many_requests",
  TRY_AGAIN: "try_again",
  PROMOTION_CODE_NOT_FOUND: "promotion_code_not_found",
  PARTNERSHIP_NOT_FOUND: "partnership_not_found",
  PLAN_NOT_FOUND: "plan_not_found",
  REDEEM_LIMIT_REACHED: "redeem_limit_reached",
  USER_PHONE_NOT_VERIFIED: "user_phone_not_verified",
  USER_ORDER_ALREADY_PLACED: "user_order_already_placed",
  USER_PHONE_ALREADY_VERIFIED: "user_phone_already_verified",
  USER_NOT_FOUND: "user_not_found",
  MEMBER_CARD_NOT_FOUND: "member_card_not_found",
  MAX_NUMBER_OF_TICKETS_REACHED: "max_number_of_tickets_reached",
  MAX_NUMBER_OF_REQUESTS_REACHED: "max_number_of_requests_reached",
  PROGRAM_NOT_FOUND: "program_not_found",
  TRANSFER_TO_OWN_PROHIBITED: "transfer_to_own_prohibited",
  TO_MEMBER_CARD_NOT_FOUND: "to_member_card_not_found",
  CREATE_TICKET_ERROR: "create_ticket_error",
  AUTH_CHARGE_ERROR: "auth_charge_error",
  CONNECT_ERROR: "connect_error",
  ERROR_INVALID_PASSWORD: "error_invalid_password",
  ERROR_WRONG_PINCODE: "error_wrong_pincode",
  ERROR_ADDED_BY_ANOTHER_USER: "error_added_by_another_user",
  COOL_DOWN_LIMIT_REACHED: "cool_down_limit_reached",
  TOKEN_EXPIRED: "token_expired",
  TOKEN_NOT_FOUND: "token_not_found",
  INSUFFICIENT_FUNDS: "insufficient_funds",
  EXPIRED_CARD: "expired_card",
  LOST_CARD: "lost_card",
  INVALID_CARD_NUMBER: "invalid_card",
  INVALID_CARD_CVC: "invalid_cvc",
  DO_NOT_HONOR: "do_not_honor",
}

export const getLocaliceKeyFromErrorCode = (errorCode: string) => {
  switch (errorCode.toLowerCase()) {
    case errorCodes.PRODUCT_NOT_AVAILABLE:
      return translationKeys.comboOrderCheckoutProductNotAvailable
    case errorCodes.COULD_NOT_ADD_VOUCHER_TO_ORDER:
      return translationKeys.comboOrderCheckoutVoucherNotEligible
    case errorCodes.NO_TIMESLOTS_AVAILABLE:
      return translationKeys.capacityControlErrorNoTimeslotsAvailable
    case errorCodes.TIMESLOT_MAX_CAPACITY_REACHED:
    case errorCodes.TIMESLOT_CAPACITY_REACHED:
      return translationKeys.capacityControlErrorMaxCapacityReached
    case errorCodes.TIMESLOT_NOT_AVAILABLE:
      return translationKeys.capacityControlErrorSelectedTimeslotNotAvailable
    case errorCodes.MINIMUM_PRICE_NOT_MET:
      return translationKeys.comboOrderCheckoutDeliveryMinimumPriceNotMetDetails
    case errorCodes.VENUE_CLOSED_FOR_ORDERS:
      return translationKeys.comboOrderCheckoutClosedForOrders
    case errorCodes.OUTSIDE_OPENING_HOURS:
      return translationKeys.comboOrderCheckoutOutsideOpeningHours
    case errorCodes.TERMS_NOT_ACCEPTED:
      return translationKeys.inputTermsNotChecked
    case errorCodes.USER_EXISTS:
    case errorCodes.VALIDATION_ERROR:
      return translationKeys.webConfirmCodeCodeUserExists
    case errorCodes.CODE_IS_NO_LONGER_VALID:
      return translationKeys.comboCodeFailedSubtext
    case errorCodes.CODE_ALREADY_USED:
    case errorCodes.CUSTOMER_ALREADY_ADDED:
      return translationKeys.webEntercodeCodeAlreadyUsed
    case errorCodes.CODE_NOT_FOUND:
    case errorCodes.RESOURCE_NOT_FOUND:
    case errorCodes.ITEM_NOT_FOUND:
    case errorCodes.PROMOTION_CODE_NOT_FOUND:
    case errorCodes.PARTNERSHIP_NOT_FOUND:
      return translationKeys.webEntercodeCodeNotFound
    case errorCodes.REDEEM_LIMIT_REACHED:
      return translationKeys.webEntercodeMaximumExceeded
    case errorCodes.USER_PHONE_NOT_VERIFIED:
      return translationKeys.webEntercodeUserNotVerified
    case errorCodes.USER_ORDER_ALREADY_PLACED:
      return translationKeys.webEntercodeOrderAlreadyPlaced
    case errorCodes.USER_PHONE_ALREADY_VERIFIED:
      return translationKeys.webEntercodeUserAlreadyVerified
    case errorCodes.UNKNOWN_USER_OR_WRONG_PASSWORD:
      return translationKeys.webLoginFailedLogin
    case errorCodes.NOT_FOUND:
      return translationKeys.webConfirmCodeCodeNotFound
    case errorCodes.TOKEN_EXPIRED:
      return translationKeys.comboPasswordResetTokenExpired
    case errorCodes.TOKEN_NOT_FOUND:
      return translationKeys.comboPasswordResetTokenNotFound
    case errorCodes.INSUFFICIENT_FUNDS:
      return translationKeys.comboPaymentErrorInsufficientFunds
    case errorCodes.EXPIRED_CARD:
      return translationKeys.comboPaymentErrorCardExpired
    case errorCodes.LOST_CARD:
      return translationKeys.comboPaymentErrorCardLost
    case errorCodes.INVALID_CARD_NUMBER:
      return translationKeys.comboPaymentErrorCardInvalid
    case errorCodes.INVALID_CARD_CVC:
      return translationKeys.comboPaymentErrorCardInvalidCvc
    case errorCodes.DO_NOT_HONOR:
      return translationKeys.comboPaymentErrorDoNotHonor
    // We can incrementally add error messages here
    case errorCodes.ERROR_CARD_NOT_NUMBER_FOUND:
    case errorCodes.TRY_AGAIN:
    case errorCodes.TOO_MANY_REQUESTS:
    case errorCodes.NOT_TRIAL_ELIGIBLE:
    case errorCodes.TRY_AGAIN_LATER:
    case errorCodes.REFERRAL_NOT_ACTIVE:
    case errorCodes.PLAN_NOT_FOUND:
    case errorCodes.INVALID_REQUEST:
    case errorCodes.IS_BLANK_ERROR:
    case errorCodes.MISSING_EMAIL_VERIFICATION_CODE:
    case errorCodes.UNKNOWN_OR_EXPIRED_EMAIL_VERIFICATION_CODE:
    case errorCodes.UNKNOWN_USERNAME_OR_PASSWORD:
    case errorCodes.INVALID_OR_EXPIRED_EMPLOYEE_ID:
    case errorCodes.MISSING_ACTIVE_SUBSCRIPTION:
    case errorCodes.EMPLOYEE_ID_ALREADY_USED:
    case errorCodes.ERROR_CARD_NUMBER_ALREADY_REGISTERED:
    case errorCodes.ERROR_UNKNOWN_CARD_TYPE:
    case errorCodes.ACTIVE_SUBSCRIPTION_CARD_CAN_NOT_BE_REMOVED:
    case errorCodes.MAX_ACCOUNT_BALANCE_REACHED:
    case errorCodes.ERROR_CHARGE:
    case errorCodes.REQUIRES_ACTION:
    case errorCodes.INVALID_PAYMENT_METHOD:
    case errorCodes.MAX_DEPOSIT_AMOUNT_REACHED:
    case errorCodes.INVALID_CURRENCY:
    case errorCodes.USER_NOT_FOUND:
    case errorCodes.MEMBER_CARD_NOT_FOUND:
    case errorCodes.MAX_NUMBER_OF_TICKETS_REACHED:
    case errorCodes.MAX_NUMBER_OF_REQUESTS_REACHED:
    case errorCodes.PROGRAM_NOT_FOUND:
    case errorCodes.TRANSFER_TO_OWN_PROHIBITED:
    case errorCodes.TO_MEMBER_CARD_NOT_FOUND:
    case errorCodes.CREATE_TICKET_ERROR:
    case errorCodes.AUTH_CHARGE_ERROR:
    case errorCodes.CONNECT_ERROR:
    case errorCodes.ERROR_INVALID_PASSWORD:
    case errorCodes.ERROR_WRONG_PINCODE:
    case errorCodes.ERROR_ADDED_BY_ANOTHER_USER:
    case errorCodes.COOL_DOWN_LIMIT_REACHED:
      return undefined
    default:
      return undefined
  }
}
